var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showListenFreeTag)?_c('p',{staticClass:"tag"},[_vm._v("Listen Free")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }